import React, { useState } from "react";
import { NavLink as RouterLink } from "react-router-dom";
import useStyles from "./Style";
import { Box, CardMedia, Link } from "@material-ui/core/";
import Button from "@material-ui/core/Button";
import Logo from "../../assets/Logo.png";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import SearchIcon from "@material-ui/icons/Search";
import { useDispatch, useSelector } from "react-redux";
import { searchProduct } from "../../Redux/actions/searchProduct";

const Navbar = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const url = document.URL.split("/"); //En "url" hay un array conteniendo lo que fue separado con las barras: ["http:", "", "localhost3000", ""]
  const click = () => {
    window.scrollTo(0, 0);
  };

  const [busqueda, setBusqueda] = useState(false);
  const [producto, setProducto] = useState({
    producto: "",
  });

  const buscar = () => {
    dispatch(searchProduct(producto));
  };

  const inputHandler = (e) => {
    setProducto({
      ...producto,
      producto: e.currentTarget.value,
    });

    console.log(producto);
  };

  const openBusqueda = () => {
    setBusqueda(!busqueda);
  };
  return (
    <div className="navbar">
      <AppBar position="fixed" color="inherit">
        <Toolbar className={classes.navbar}>
          <Link className={classes.logoContainer} component={RouterLink} to="/">
            <CardMedia className={classes.logo} component="img" image={Logo} />
          </Link>
          <Box className={classes.links} component="div">
            <Link
              component={RouterLink}
              activeClassName={classes.active}
              exact
              to="/"
              style={{ textDecoration: "none" }}
            >
              <Button
                size="small"
                variant="text"
                className={classes.btn2}
                activeClassName={classes.active2}
                component={RouterLink}
                exact
                to="/"
                onClick={click}
              >
                Inicio
              </Button>
            </Link>
            <Link
              component={RouterLink}
              activeClassName={classes.active}
              to="/aboutus"
              style={{ textDecoration: "none" }}
            >
              <Button
                size="small"
                variant="text"
                activeClassName={classes.active2}
                component={RouterLink}
                to="/aboutus"
                className={classes.btn2}
                onClick={click}
              >
                Nosotros
              </Button>
            </Link>
            <Link
              style={{ textDecoration: "none" }}
              component={RouterLink}
              activeClassName={classes.active}
              to="/products"
            >
              <Button
                size="small"
                variant="text"
                activeClassName={classes.active2}
                component={RouterLink}
                to="/products"
                className={classes.btn2}
                onClick={click}
              >
                Productos
              </Button>
            </Link>
            <Link
              style={{ textDecoration: "none" }}
              component={RouterLink}
              activeClassName={classes.active}
              to="/content"
            >
              <Button
                size="small"
                variant="text"
                activeClassName={classes.active2}
                component={RouterLink}
                to="/content"
                className={classes.btn2}
                onClick={click}
              >
                Contenido
              </Button>
            </Link>
            <Link
              style={{ textDecoration: "none" }}
              component={RouterLink}
              activeClassName={classes.active}
              to="/contact"
            >
              <Button
                size="small"
                variant="text"
                activeClassName={classes.active2}
                component={RouterLink}
                to="/contact"
                className={classes.btn2}
                onClick={click}
              >
                Contacto
              </Button>
            </Link>
            <Button onClick={openBusqueda} size="small">
              <SearchIcon></SearchIcon>
            </Button>
            {busqueda ? (
              <div className={classes.inputfloat}>
                <input type="text" onChange={inputHandler} />
                <button onClick={buscar}> Test</button>
              </div>
            ) : (
              ""
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <div className={classes.offset} />
    </div>
  );
};

export default Navbar;
